<template>
  <div class="bienvenida-page">
    <!-- Fondos Fijos de la Página -->
    <div class="background-fixed"></div>
    <div class="white-overlay"></div>

    <div ref="containerRef" class="bienvenida-container">
      <div class="contenido-bienvenida">
        
        <!-- Contenedor Principal de la Imagen con su Fondo Decorativo de Arco -->
        <div class="modulo-foto-wrap">
          <!-- Elemento .avif decorativo que va justo detrás simulando el arco de la imagen -->
          <div class="fondo-arco-decorativo" ref="arcoDecorativoRef">
            <img src="@/assets/3.avif" alt="Decoración Arco" class="arco-media" />
          </div>

          <!-- Foto Principal en Forma de Arco -->
          <div class="imagen-contenedor-arco" ref="fotoRef">
            <img
              src="@/assets/INVITACIONVALE-62(3).webp"
              alt="Foto bienvenida"
              class="foto-bienvenida"
              loading="lazy"
            />
          </div>
        </div>

        <!-- Textos Consecutivos -->
        <p class="agradecimiento-intro" ref="agradecimientoIntroRef">
          Con todo mi amor,<br> agradezco a mis Padres
        </p>
<br>
      <h2 class="nombre-destacado" ref="nombreDestacadoRef">Juan Paulo Anaya
<br>

  <span class="ampersand">&amp;</span><br>

   Gabriela Duarte
</h2>
<br>
        <p class="agradecimiento-cuerpo" ref="agradecimientoCuerpoRef">
          Por su apoyo incondicional, por acompañarme en cada paso del camino y por hacer posible para mí este día tan especial.
        </p>

        <!-- Sección de Padrinos (Formato similar a Padres pero más chico) -->
        <br>
        <p class="agradecimiento-intro padrinos-intro" ref="padrinosIntroRef">
          Mis Padrinos:
        </p>
        <br>
        <h3 class="nombre-destacado padrinos-nombres" ref="padrinosNombresRef">
          Fernando Duarte
          <br>
          <span class="ampersand ampersand-padrinos">&amp;</span>
          <br>
          Cristina Gutiérrez
        </h3>

        <!-- Elementos Decorativos Inferiores con la bola de disco grande -->
        <div class="decoraciones-inferiores" ref="decoracionesRef">
          <img src="@/assets/cora.avif" alt="Silver Star" class="decoracion-item estrella-grande" />
          <img src="@/assets/bola1.avif" alt="Small Star" class="decoracion-item estrella-chica" />
          <img src="@/assets/lazo.avif" alt="Disco Ball" class="decoracion-item disco-1" />
          <img src="@/assets/estre.png" alt="Disco Ball" class="decoracion-item disco-2" />

          <!-- Bola de disco principal (Grande utilizando tu archivo bola.avif) -->
          <div class="decoracion-item disco-grande-avif">
            <img src="@/assets/bola.avif" alt="Main Disco Ball" class="bola-avif-media" />
          </div>
        </div>

      </div>
    </div>
    <div class="rasgado rasgado-inferior"></div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPage',
  setup() {
    const containerRef = ref(null)
    const arcoDecorativoRef = ref(null)
    const fotoRef = ref(null)
    const agradecimientoIntroRef = ref(null)
    const nombreDestacadoRef = ref(null)
    const agradecimientoCuerpoRef = ref(null)
    const decoracionesRef = ref(null)
    
    // Referencias para la animación consecutiva de los padrinos
    const padrinosIntroRef = ref(null)
    const padrinosNombresRef = ref(null)

    const animateSection = () => {
      const tl = gsap.timeline()

      // Fuerza que todos los estados iniciales estén ocultos antes de arrancar la línea de tiempo
      gsap.set([
        fotoRef.value, 
        arcoDecorativoRef.value, 
        agradecimientoIntroRef.value, 
        nombreDestacadoRef.value, 
        agradecimientoCuerpoRef.value,
        padrinosIntroRef.value,
        padrinosNombresRef.value
      ], { opacity: 0 })

      // 1. Entrada del Arco decorativo trasero (Aparece expandiéndose)
      tl.fromTo(
        arcoDecorativoRef.value,
        { scale: 0.5, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.2, ease: 'power3.out' }
      )
      // 2. Entrada de la Foto Principal (Cae ligeramente y se agranda desde el centro del arco)
      .fromTo(
        fotoRef.value,
        { scale: 0.7, y: -40, opacity: 0 },
        { scale: 1, y: 0, opacity: 1, duration: 1.1, ease: 'back.out(1.4)' },
        '-=0.8' 
      )
      // 3. Texto "With all my love..." (Aparece subiendo fluidamente)
      .fromTo(
        agradecimientoIntroRef.value,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power2.out' },
        '-=0.5'
      )
      // 4. Nombre Principal Destacado (Gran impacto elástico)
      .fromTo(
        nombreDestacadoRef.value,
        { y: 50, scale: 0.8, opacity: 0 },
        { y: 0, scale: 1, opacity: 1, duration: 0.9, ease: 'back.out(1.7)' },
        '-=0.5'
      )
      // 5. Bloque de Texto inferior
      .fromTo(
        agradecimientoCuerpoRef.value,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' },
        '-=0.6'
      )
      // 5.1. Título "My Godparents" (Sube fluidamente)
      .fromTo(
        padrinosIntroRef.value,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power2.out' },
        '-=0.5'
      )
      // 5.2. Nombres de los Padrinos (Entrada suave consecutiva)
      .fromTo(
        padrinosNombresRef.value,
        { y: 35, scale: 0.95, opacity: 0 },
        { y: 0, scale: 1, opacity: 1, duration: 0.8, ease: 'back.out(1.2)' },
        '-=0.4'
      )
      // 6. Grupo de decoraciones inferiores incluyendo las esferas de disco y la gran bola.avif
      .fromTo(
        decoracionesRef.value.querySelectorAll('.decoracion-item'),
        { y: 90, opacity: 0, scale: 0.3, rotation: -45 },
        { 
          y: 0, 
          opacity: 1, 
          scale: 1, 
          rotation: 0,
          duration: 1, 
          ease: 'back.out(1.5)',
          stagger: 0.12 
        },
        '-=0.4'
      )
      // 7. Animación en bucle infinito (Flotado y rotación orgánica para simular pista de baile)
      .add(() => {
        const items = decoracionesRef.value.querySelectorAll('.decoracion-item');
        items.forEach((item, index) => {
          gsap.to(item, {
            y: index % 2 === 0 ? '+=12' : '-=10',
            rotation: index % 2 === 0 ? 5 : -5,
            duration: 2 + (index * 0.3),
            ease: 'sine.inOut',
            repeat: -1,
            yoyo: true
          })
        })
      })
    }

    // --- EFECTO ESTRELLAS BLING BLING ---
    const crearCieloEstrellado = () => {
      const totalEstrellas = 45;
      const fondo = containerRef.value;
      if (!fondo) return;

      for (let i = 0; i < totalEstrellas; i++) {
        const estrella = document.createElement('div');
        estrella.className = Math.random() > 0.5 ? 'fast-sparkle' : 'fast-dot';

        const posX = Math.random() * 100;
        const posY = Math.random() * 100;
        const size = Math.random() * 12 + 6;

        estrella.style.left = `${posX}%`;
        estrella.style.top = `${posY}%`;
        estrella.style.width = `${size}px`;
        estrella.style.height = `${size}px`;

        fondo.appendChild(estrella);

        gsap.fromTo(estrella,
          { opacity: 0, scale: 0, rotation: 0 },
          {
            opacity: Math.random() * 0.8 + 0.2,
            scale: Math.random() * 0.5 + 0.8,
            rotation: Math.random() > 0.5 ? 180 : -180,
            duration: Math.random() * 0.6 + 0.4, 
            delay: Math.random() * 1.5,
            repeat: -1,
            yoyo: true,
            ease: "power1.inOut"
          }
        );
      }
    };

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animateSection()
          crearCieloEstrellado()
          obs.unobserve(entry.target)
        }
      }, { threshold: 0.1 })

      if (containerRef.value) observer.observe(containerRef.value)
    })

    return {
      containerRef,
      arcoDecorativoRef,
      fotoRef,
      agradecimientoIntroRef,
      nombreDestacadoRef,
      agradecimientoCuerpoRef,
      decoracionesRef,
      padrinosIntroRef,
      padrinosNombresRef
    }
  }
}
</script>

<style scoped>
.bienvenida-page {
  position: relative;
  margin-top: 30px;
  margin-bottom: 0px;
  overflow: hidden;
}

.background-fixed {
  position: fixed;
  inset: 0;
  background-image: url('@/assets/fondodisco.avif');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -3;
}

.white-overlay {
  position: fixed;
  inset: 0;
  background: rgba(12, 12, 12, 0.85);
  z-index: -2;
}

.bienvenida-container {
  position: relative;
  width: 100%;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
}

.contenido-bienvenida {
  max-width: 480px;
  width: 100%;
  text-align: center;
  position: relative;
  z-index: 1;
}

/* --- ENVOLTURA E IMAGEN DE ARCO --- */
.modulo-foto-wrap {
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fondo-arco-decorativo {
  position: absolute;
  top: -15px;
  width: 106%;
  height: 106%;
  z-index: 1;
  pointer-events: none;
}


/* =========================
   RASGADOS
========================= */
.rasgado{
  position:absolute;
  left:0;
  width:100%;
  height:50px;
  background:#ffffff;
  z-index:3;
  margin-top:-40px;
  pointer-events:none;
}

.rasgado-superior{
  top:0;
    background:#ffffff;

  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior{
  bottom:0;
      background:#ffffff;

  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}

.arco-media {
  width: 100%;
  margin-top:-180px;
  height: 100%;
  object-fit: contain;
}

.imagen-contenedor-arco {
  width: 100%;
  position: relative;
  z-index: 2;
  overflow: hidden;
  
  border-top-left-radius: 220px;
  border-top-right-radius: 220px;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.6);
}

.foto-bienvenida {
  width: 100%;
  height: auto;
  display: block;
}

/* --- TEXTOS --- */
.agradecimiento-intro {
  font-size: 21px;
  color: #e5e5e5;
  margin-bottom: 14px;
  font-family: 'Playfair Display', serif;
  font-style: italic;
}

.padrinos-intro {
  font-size: 18.9px; /* Escala un poco más chica que los padres */
  margin-top: 10px;
}

.nombre-destacado {
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 1.5px;
  color: #ffffff;
  margin-bottom: 20px;
  font-family: 'british', sans-serif;
  text-shadow: 0 4px 15px rgba(255, 255, 255, 0.25);
  text-align: center;
  line-height: 1.2;
}

.padrinos-nombres {
  font-size: 20px; /* Forzamos un tamaño menor para los padrinos */
  letter-spacing: 1.2px;
  margin: 0 auto;
}

.agradecimiento-cuerpo {
  font-size: 18px;
  line-height: 1.6;
  color: #b3b3b3;
  max-width: 92%;
  margin: 0 auto 40px;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

/* --- DECORACIONES INFERIORES Y BOLA DE DISCO GRANDE --- */
.decoraciones-inferiores {
  position: relative;
  width: 100%;
  height: 170px;
  margin-top: 15px;
}

.ampersand {
  display: inline-block;
  font-size: 5rem;   
  font-family: "Cormorant Garamond", serif;
  font-weight: 400;
  color: rgba(255,255,255,.35);
  line-height: 0.8;
  margin: 8px 0;
}

.ampersand-padrinos {
  font-size: 3.8rem; /* El ampersand de los padrinos también reduce su escala proporcionalmente */
  margin: 4px 0;
}

.decoracion-item {
  position: absolute;
  bottom: 0;
  margin-top: 20px !important;
  will-change: transform, opacity;
}

.estrella-grande {
  left: -18%;
  width: 120px;
  margin-top: 218px !important;
    transform: rotate(295deg);

  z-index: 2;
}
.estrella-chica {
  right: 35%;
  bottom: 20px !important;
  width: 90px;
  z-index: 1;
}

.disco-1 {
  right: -14%;
  bottom: -70px !important;
  width: 195px;
  z-index: 3;
  transform: rotate(295deg);
}
.disco-2 {
  left:  17%;
  bottom: -5px;
  width: 65px;
  z-index: 3;
  transform: rotate(295deg);
}


/* Contenedor especial para recortar de forma redonda el archivo bola.avif */
.disco-grande-avif {
  right: -5px;
  bottom: -25px;
  width: 190px; /* Tamaño destacado y expandido */
  height: 190px;
  z-index: 4;
  overflow: hidden;
  clip-path: circle(50% at 50% 50%); /* Hace que el archivo sea perfectamente circular */
}

.bola-avif-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* --- BLING BLING FONDO --- */
:deep(.fast-dot) {
  position: absolute;
  background: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 70%);
  border-radius: 50%;
  pointer-events: none;
  z-index: -1;
}

:deep(.fast-sparkle) {
  position: absolute;
  pointer-events: none;
  z-index: -1;
  background: white;
  clip-path: polygon(50% 0%, 62% 38%, 100% 50%, 62% 62%, 50% 100%, 38% 62%, 0% 50%, 38% 38%);
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.9);
}

</style>